import { allExamEventStates } from '../../status-transition-rules/exam-event-transitions';
import TableFilter from '../table-models/TableFilter';

export const defaultExamEventsFilters: TableFilter[] = [
    { field: 'hideCanceled', label: 'Hide Canceled', value: true },
    { field: 'name', label: 'Exam Name', value: '' },
    { field: 'ato', label: 'ATO', value: '' },
    { field: 'state', label: 'State', value: '', availableStates: allExamEventStates },
];
